import * as React from "react";
import { useDispatch } from "react-redux";
import { Box } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import { showToast } from "../../store/slices/common";
import TablePagination from "../../components/Table/TablePagination";
import CustomSelectField from "../../components/Select";
import Button from "../../components/Button";
import ConfirmDelete from "./ConfirmDelete";
import { deleteCategory } from "../../http/auth";
import CreateCategory from "./CreateCategory";
import ViewSubCategory from "./ViewSubCategory";

const CategoryTable = ({
  setLoading,
  columns,
  rows,
  page,
  setPage,
  nextId,
  onNextClick,
  onPrevClick,
  rowsPerPage,
  totalCount,
  type,
  setType,
  getCategories,
}) => {
  // const [openEditModal, setOpenEditModal] = React.useState(false)
  const [openAddModal, setOpenAddModal] = React.useState(false);
  const [openConfirmDeleteModal, setOpenConfirmDeleteModal] =
    React.useState(false);
  const [deleteId, setDeleteId] = React.useState("");
  const [editableRow, setEditableRow] = React.useState({});
  const [viewableRow, setViewableRow] = React.useState({});
  const [isView, setIsView] = React.useState({});
  const [isEdit, setIsEdit] = React.useState(false);
  const [openViewModal, setOpenViewModal] = React.useState(false);

  const deleteCategoryHandler = (id) => {
    setDeleteId(id);
    setOpenConfirmDeleteModal(true);
  };

  const confirmDelete = async () => {
    try {
      setLoading(true);
      await deleteCategory(deleteId);
      await getCategories(type.toLowerCase());
      dispatch(
        showToast({ msg: "Category d?eleted successfully", color: "success" })
      );
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  const openAddModalHandler = (row, edit) => {
    if (edit) {
      setEditableRow(row);
      setIsEdit(true);
    } else {
      setEditableRow({});
      setIsEdit(false);
    }
    setOpenAddModal(true);
  };

  const openSubCategoryModalHandler = (row) => {
    setIsView(true);
    setViewableRow(row);
    setOpenViewModal(true);
  };

  const renderContent = (value, rowIndex, row) => {
    console.log(value, row, "fsdfsd");
    if (value === "-") {
      return (
        <>
          {/* {type === "Expenses" && (
            <VisibilityOutlinedIcon
              sx={{ color: "blue", cursor: "pointer" }}
              onClick={() => openSubCategoryModalHandler(row)}
            />
          )} */}
          <ModeEditOutlineOutlinedIcon
            sx={{ color: "blue", cursor: "pointer", marginLeft: "10px" }}
            onClick={() => openAddModalHandler(row, true)}
          />
          <DeleteOutlineIcon
            sx={{ color: "red", cursor: "pointer", marginLeft: "10px" }}
            onClick={() => deleteCategoryHandler(row?.id)}
          />
        </>
      );
    } else if (typeof value === "number") {
      return (page - 1) * 10 + rowIndex + 1;
    } else if (Array.isArray(value)) {
      return value.length;
    } else return value.en;
  };

  return (
    <div style={{ height: "calc(100% - 61px)" }}>
      <ConfirmDelete
        open={openConfirmDeleteModal}
        setOpen={setOpenConfirmDeleteModal}
        confirmDelete={confirmDelete}
      />
      <CreateCategory
        open={openAddModal}
        setOpen={setOpenAddModal}
        type={type}
        getCategories={getCategories}
        editableRow={editableRow}
        setEditableRow={setEditableRow}
        isEdit={isEdit}
        isView={isView}
        setPage={setPage}
      />
      <ViewSubCategory
        open={openViewModal}
        setOpen={setOpenViewModal}
        viewableRow={viewableRow}
      />
      <TableContainer
        sx={{
          width: "calc(100% - 2px)",
          borderRadius: "10px",
          marginTop: "12px",
          maxHeight: "calc(100% - 68px)",
          border: "1px solid rgba(224, 224, 224, 1)",
          overflowY: "auto",
        }}
      >
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              <TableCell colSpan={columns.length} style={{ padding: 0 }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "2rem",
                    padding: "1rem",
                    background: "#fff",
                    position: "sticky",
                    top: 0,
                    zIndex: 1,
                  }}
                >
                  <Box sx={{ width: "180px" }}>
                    <CustomSelectField
                      isCategory={true}
                      type="text"
                      variant="outlined"
                      placeholder="Category"
                      value={type}
                      edit={false}
                      selectOptions={["Income", "Expenses", "Savings"]}
                      border
                      onChange={setType}
                    />
                  </Box>
                  <Button
                    onClick={() => openAddModalHandler("", false)}
                    variant="contained"
                    label="Add Category"
                    style={{ width: "150px" }}
                  />
                </Box>
              </TableCell>
            </TableRow>
            <TableRow sx={{ position: "sticky", top: "80px", zIndex: "1" }}>
              {columns.map((column, index) => {
                const textAlignStyle =
                  column.label === "Action" ? "center" : "start";
                return (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{
                      minWidth: column.minWidth,
                      textAlign: textAlignStyle,
                    }}
                    sx={{
                      color: "#323C47",
                      fontSize: "16px",
                      fontWeight: "700",
                    }}
                  >
                    {column.label}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {console.log(rows, "columns")}

            {rows.map((row, rowIndex) => {
              return (
                <TableRow hover role="checkbox" tabIndex={-1} key={row?._id}>
                  {columns.map((column, ind) => {
                    const value = row[column.id];
                    const pad = value === "-" ? "10px !important" : "auto";
                    const alignment = value === "-" ? "center" : "start";

                    return (
                      <TableCell
                        key={column.id}
                        align={column.align}
                        sx={{
                          color: "#323C47",
                          fontSize: "16px",
                          height: "24px",
                          padding: pad,
                          textAlign: alignment,
                        }}
                      >
                        {renderContent(value, rowIndex, row)}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        page={page}
        nextId={nextId}
        onNextClick={onNextClick}
        onPrevClick={onPrevClick}
        totalCount={totalCount}
      />
    </div>
  );
};

export default CategoryTable;
